<template>
    <button
        :class="{
            'assistent-detail-tag-item-button': true,
            'assistent-detail-tag-item-button--active': props.active,
        }"
        type="button"
    >
        <div class="assistent-detail-tag-item-button__dot" :style="{ backgroundColor: props.tag.value }" />

        <div class="assistent-detail-tag-item-button__label" :title="props.tag.label">
            {{ props.tag.label }}
        </div>

        <div class="assistent-detail-tag-item-button__checkbox">
            <div>
                <svg-icon
                    :icon="CheckIcon"
                    size="xxs"
                    color="white"
                    is-custom-icon
                />
            </div>
        </div>
    </button>
</template>

<script setup lang="ts">
    import CheckIcon from '@keyvue/one-awesome-icons/icons/regular/check.svg?component';

    const props = defineProps<{
        tag: { value: string, label: string }
        active?: boolean,
    }>();
</script>

<style scoped lang="scss">
    .assistent-detail-tag-item-button {
        display: flex;
        gap: size(sm);
        width: 100%;
        border: none;
        background: none;
        padding: 0;
        align-items: center;
        cursor: pointer;
        font-size: font-size(sm);

        &--active {
            & .assistent-detail-tag-item-button__checkbox {
                & > div {
                    background-color: var(--theme-colors-default--primary);
                    border-color: var(--theme-colors-default--primary);
                }
            }
        }

        &__dot {
            width: 5px;
            height: 5px;
            border-radius: 50%;
        }

        &__label {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        &__checkbox {
            margin-left: auto;
            display: flex;

            & > div {
                content: "";
                display: flex;
                align-items: center;
                justify-content: center;
                height: 16px;
                width: 16px;
                border-radius: 2px;
                border: 2px solid var(--theme-colors-default--gray-400);
                box-sizing: border-box;
                transition: background-color .1s;
            }
        }
    }
</style>
